export const fontfaces = `
@font-face {
  font-family: Tenon;
  src: local(Tenon-Regular), url('/static/Tenon-Regular.woff') format('woff');
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;
}
@font-face {
  font-family: Tenon;
  src: local(Tenon-Medium), url('/static/Tenon-Medium.woff') format('woff');
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
}
@font-face {
  font-family: Tenon;
  src: local(Tenon-Bold), url('/static/Tenon-Bold.woff') format('woff');
  font-weight: 700;
  font-style: normal;
  font-stretch: normal;
}
@font-face {
  font-family: Tenon;
  src: local(Tenon-X-Bold), url('/static/Tenon-X-Bold.woff') format('woff');
  font-weight: 800;
  font-style: normal;
  font-stretch: normal;
}
`;
